import { CurrencyPipe, formatCurrency } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import {
  AlertController,
  IonInput,
  IonModal,
  LoadingController,
  ModalController,
  ToastController,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { NuveiOpenOrderResponse, NuveiPrePayment } from '@app/@shared/models/nuvei.model';
import { WalletApiService } from '@app/@shared/services/wallet-api.service';
import { Credentials } from '@app/auth';
import { WalletTypeService } from '@app/@shared/services/wallet-type.service';
import { WalletService } from '@app/@shared/services/wallet.service';
import { NuveiService } from '@app/@shared/services/nuvei.service';
import { WalletRechargeResponse } from '@app/@shared/models/wallet.model';
import { Subscription } from 'rxjs';
import { TransactionService } from '@app/@shared/services/transaction.service';
import { TrackingService } from '@app/@shared/services/tracking.service';
import { AnalyticsEventName } from '@app/@shared/models/tracking.model';
import { environment } from '@env/environment';
import { TopService } from '@app/@shared/services/top.service';
import { CardService } from '@app/@shared/services/card.service';
import { CampaignService } from '@app/@shared/services/campaign.service';

declare const zE: any; // Declare Zendesk API globally
declare const checkout: any;

@Component({
  selector: 'app-add-funds',
  templateUrl: './add-funds.component.html',
  styleUrl: './add-funds.component.scss',
})
export class AddFundsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('modal', { static: false }) modal?: IonModal;
  @ViewChild('inputAmount') inputAmount!: IonInput;
  balance = 0;
  isLoading = true;
  // cards: NuveiCard[] = [];
  cardSelected = 'new';
  cardIcon = 'generic';
  walletApiS?: WalletApiService;
  credentials!: Credentials;
  walletTypeS?: WalletTypeService;
  walletS?: WalletService;
  nuveiS?: NuveiService;
  transactionS?: TransactionService;
  topS?: TopService;
  cardS?: CardService;

  amount = 200;
  mins = [
    {
      min: 50,
      mp: 'cc_card',
    },
    {
      min: 100,
      mp: 'apmgw_STPmex',
    },
    {
      min: 100,
      mp: 'apmgw_PayCash',
    },
    {
      min: 100,
      mp: 'generic',
    },
  ];
  mp = 'generic';
  max = 5000;
  min = 100;
  limit = 5000;

  subscriptions: Subscription[] = [];
  transactionId = '';
  loadingItem?: HTMLIonLoadingElement;
  private nuveiScript: HTMLScriptElement | null = null; // Referencia al script

  constructor(
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private translateS: TranslateService,
    private alertCtrl: AlertController,
    private renderer: Renderer2,
    private toastCtrl: ToastController,
    private trackingS: TrackingService,
    private campaignS: CampaignService
  ) {}

  ngAfterViewInit() {
    this.modal?.didPresent.subscribe(() => {
      if (zE) {
        zE('webWidget', 'hide'); // Hide Zendesk chat when modal opens
      }
    });

    this.modal?.didDismiss.subscribe(() => {
      if (zE) {
        zE('webWidget', 'show'); // Show Zendesk chat when modal closes
      }
    });
  }

  ngOnInit(): void {
    // console.log('limit', this.limit);
    // if (this.limit < 0) {
    //   this.modalCtrl.dismiss(null, 'close');
    //   return;
    // }
    if (this.limit < this.max) {
      this.max = this.limit;
    }
    this.loadNuveiScript();
    setTimeout(() => {
      this.inputAmount.setFocus();
    }, 1000);
  }

  loadNuveiScript() {
    const script = this.renderer.createElement('script');
    script.src = 'https://cdn.safecharge.com/safecharge_resources/v1/checkout/checkout.js';
    script.type = 'text/javascript';
    script.onload = () => this.getData();
    this.renderer.appendChild(document.body, script);

    // Guardar una referencia al script
    this.nuveiScript = script;
  }

  ngOnDestroy(): void {
    // Limpiar el script y la instancia antes de cerrar el modal
    this.cleanupNuveiResources();

    this.subscriptions.forEach((s) => s.unsubscribe());
    this.subscriptions = [];
  }

  async dismiss(role: string) {
    if (role === 'close' || role === 'expired') this.cancelRecharge();
    if (role === 'approved') {
      this.loadingItem = await this.loadingCtrl.create({
        message: this.translateS.instant('nuvei.loading.confirmation'),
      });

      await this.loadingItem.present();
    } else {
      await this.loadingItem?.dismiss();
      this.modalCtrl.dismiss(null, role);
    }
  }

  async getData() {
    this.isLoading = true;

    if (this.walletS) {
      this.subscriptions.push(this.walletS.balanceChange.subscribe((b) => (this.balance = b)));
      const { balance } = await this.walletS.getBalance();
      this.balance = balance;
    }

    this.openCheckout();
  }

  get founds() {
    return [50, 100, 200, 300, 500, 800, 1000, 2000, 3000, 4000, 5000].filter(
      (f) => this.limit === 0 || f <= this.limit
    );
  }

  async continue() {
    this.openCheckout();
  }

  async initRecharge() {
    if (!this.walletApiS) {
      return;
    }
    if (!this.walletTypeS) {
      return;
    }
    if (!this.walletS) {
      return;
    }
    if (!this.credentials) {
      return;
    }
    if (!this.nuveiS) {
      return;
    }

    await this.nuveiS.saveUser();

    const id = this.credentials.id;
    const wallets = await this.walletS.getByCustomerId(id);

    const walletTypes = await this.walletTypeS.getAll();
    const loteria = walletTypes.find((w) => w.walletName === 'loteria');

    let wloteria = wallets.find((w) => (w.walletTypeId as any).id === loteria?.uid)!;

    const response = (await this.walletApiS.initiateWalletRechargeUser({
      amount: this.amount,
      walletId: wloteria?.id,
    })) as any;

    // await loading.dismiss();

    return response.init as WalletRechargeResponse;
  }

  async cancelRecharge() {
    if (!this.walletApiS) {
      return;
    }
    if (!this.walletTypeS) {
      return;
    }
    if (!this.walletS) {
      return;
    }
    if (!this.credentials) {
      return;
    }
    if (!this.transactionId) {
      return;
    }

    const response = true; //(await this.walletApiS.cancelWalletRechargeUser(this.transactionId)) as boolean;

    return response;
  }

  async openCheckout() {
    this.isLoading = true;
    if (!this.transactionS) return;
    const response = await this.initRecharge();
    if (!response) return;
    this.transactionId = response.transactionId;

    const sub = this.transactionS.subscribe(response.transactionId).subscribe(async (t) => {
      if (this.walletS && t && t.status === 'completed') {
        const { balance } = await this.walletS.getBalance();
        this.balance = balance;

        const currencyPipe = new CurrencyPipe('es-MX');

        const alert = await this.alertCtrl.create({
          header: 'Recarga exitosa',
          subHeader: `Tu recarga de  ${currencyPipe.transform(this.amount, 'MXN')} fue exitosa`,
          // message: this.translateS.instant(
          //   s && s.status === 'completed' ? 'nuvei.success.process' : 'nuvei.error.process'
          // ),
          buttons: ['Ok'],
        });
        this.transactionId = '';

        await alert.present();
        this.dismiss('post-approved');
      }
    });

    this.subscriptions.push(sub);

    const role = await this.initializeNuveiCheckout(response.nuvei);

    if (role) {
      if (role === 'approved') {
        this.transactionId = '';
        await this.dismiss('approved');
      } else if (role === 'pending') {
        const alert = await this.alertCtrl.create({
          header: 'Transacción pendiente',
          message: 'Una vez confirmado el pago por la entidad financiera se incrementará tu saldo automáticamente',
          buttons: [
            {
              text: 'Ok',
            },
          ],
        });

        await alert.present();
        this.transactionId = '';
        await this.dismiss('pending');
      } else if (role === 'expired') {
        await this.dismiss('expired');
      }
    } else {
      // await this.cancelRecharge();
    }
  }

  async initializeNuveiCheckout(response: NuveiOpenOrderResponse): Promise<'approved' | 'pending' | 'expired' | null> {
    return new Promise((resolve) => {
      if (!this.credentials) return;
      if (!checkout) return;

      //  console.log(JSON.stringify(response, null, 2));

      const configCheckout = {
        sessionToken: response.sessionToken,
        env: environment.production ? 'prod' : 'int', // Nuvei API environment – 'int' (integration) or 'prod' (production – default if omitted)
        merchantSiteId: response.merchantSiteId,
        merchantId: response.merchantId,
        currency: 'MXN',
        amount: this.amount,
        country: 'MX', //optimizes the payment method accordingly locale: 'en_US', // de it fr pt
        locale: 'es',
        fullName: this.credentials.name,
        email: this.credentials.email,
        billingAddress: {
          email: this.credentials.email,
          merchantLocale: 'es_MX',
          country: 'MX',
        },
        userDetails: {
          country: 'MX',
          merchantLocale: 'es_MX',
          language: 'es',
        },
        maskCvv: true,
        showCardLogos: true,
        savePM: 'always',
        renderTo: '#nuvei-checkout-container',
        upoRestriction: {
          maxApmUpos: 6,
          onePerApm: false,
          maxCards: 3,
        },
        // onPaymentFormChange: (pm: any, label: any, action: any, oldValue: any, newValue: any, validation: any, pasted: any) => {
        //   console.log('onPaymentFormChange =>', {pm, label, action, oldValue, newValue, validation, pasted});
        // },
        onSelectPaymentMethod: async (paymentDetails: any) => {
          //  console.log('on select payment', paymentDetails);
          // this.isNewCard = paymentDetails['paymentMethodName'] ==='cc_card' && !paymentDetails['upoName'];
          // console.log('onSelectPaymentMethod', paymentDetails['paymentMethodName']);
          this.mp = paymentDetails['paymentMethodName'];
          const mp = this.mins.find((m) => m.mp === this.mp)!;
          this.min = mp.min;
          if (this.amount < mp.min) {
            this.amount = mp.min;

            const alert = await this.alertCtrl.create({
              header: `El monto mínimo para ${this.translateS.instant(
                `nuvei.pm.${paymentDetails['paymentMethodName']}`
              )}: ${formatCurrency(this.min, 'es-MX', '$')}`,
              buttons: [this.translateS.instant('Close')],
            });

            await alert.present();
          }
          this.inputAmount.value = this.amount;
        },
        prePayment: (paymentDetails: NuveiPrePayment) => {
          return new Promise(async (resolve, reject) => {
            if (!this.walletApiS || !this.credentials) {
              reject('Wallet api service not found');
              return;
            }
            // const loading = await this.loadingCtrl.create({
            //   message: this.translateS.instant('nuvei.loading.process'),
            // });

            // await loading.present();

            if (this.mp === 'cc_card') {
              const limit = await this.getLimitForAddFunds(this.credentials!);
              //console.log({ limit });
              if (limit !== 0) {
                if (limit < 50) {
                  reject(this.translateS.instant('nuvei.limit-excedeed'));
                  return;
                }

                if (limit < this.amount) {
                  reject(
                    (this.translateS.instant('nuvei.limit-excedeed-amount') as string).replace(
                      '{{amount}}',
                      `MXN ${limit.toString()}`
                    )
                  );
                  return;
                }
              }
            }

            const credentials = this.credentials;
            // obtener el limite segun el nuvel de usuario
            const top = await this.topS?.getTop(credentials.id);
            if (!top || !top.isActive) {
              const cards = await this.cardS?.getByUserIdLast24Hours(credentials.id);
              if (cards && cards.length > 1) {
                reject(this.translateS.instant('card.unauthorized'));
                return;
              }
            }

            const previous = +(this.inputAmount.value as string | number);
            if (previous < this.min) {
              const alert = await this.alertCtrl.create({
                header: `El monto mínimo para ${this.translateS.instant(`nuvei.pm.${this.mp}`)}: ${formatCurrency(
                  this.min,
                  'es-MX',
                  '$'
                )}`,
                buttons: [this.translateS.instant('Close')],
              });

              await alert.present();
              reject('El monto mínimo es de $' + this.min);
            } else {
              const saved = await this.walletApiS!.savePaymentDataForUserRecharge({
                transactionId: response.clientUniqueId,
                paymentData: paymentDetails,
                orderData: response,
                amount: this.amount,
                method: this.mp,
              });

              // console.log(JSON.stringify(paymentDetails, null, 2));
              // console.log(JSON.stringify(saved, null, 2));

              // await loading.dismiss();
              if (typeof saved === 'string') reject(this.translateS.instant(saved));
              else if (saved) resolve(true); // or reject() or reject('Message')
              else reject('Error actualizando información de venta');
            }
          });
        },
        onPaymentEvent: (result: any) => {
          // console.log('onPaymentEvent =>', result);
        },
        onResult: async (result: any) => {
          // console.log(JSON.stringify(result, null, 2));
          if (!this.walletApiS) return;

          const resVal = result ? result['result'] : undefined;

          if (resVal === 'APPROVED') {
            this.trackWallet(
              'wallet_recharged',
              this.amount,
              resVal,
              this.mp,
              result['transactionId'],
              '',
              '',
              false,
              true
            );

            // Tracking de campaign_conversion para recargas
            this.trackCampaignConversion(this.amount, result['transactionId'], this.mp);

            // 2. Destruir la instancia del checkout si existe
            if (checkout && typeof checkout.destroy === 'function') {
              checkout.destroy();
            }

            resolve('approved');
            // this.modalController.dismiss({ result, saved: true }, 'approved');
          } else if (resVal === 'PENDING') {
            // 2. Destruir la instancia del checkout si existe
            if (checkout && typeof checkout.destroy === 'function') {
              checkout.destroy();
            }

            // this.modalController.dismiss(null, 'pending');
            resolve('pending');
          } else if (result && result['session_expired']) {
            resolve('expired');
          } else {
            // Determinar si es una cancelación o cierre voluntario por el usuario
            const isCancel =
              !result ||
              !resVal ||
              resVal === 'CANCEL' ||
              resVal === 'CANCELED' ||
              resVal === 'canceled' ||
              resVal === 'CANCELLED' ||
              resVal === 'cancelled';

            if (isCancel) {
              resolve(null);
              return;
            }

            // console.log('RESULT: ', result);
            this.trackWallet(
              'wallet_transaction_failed',
              this.amount,
              resVal || 'DECLINED',
              '',
              '',
              result['errCode'],
              '',
              false,
              false
            );

            const errorDesc = result['errorDescription'] || result['reason'] || 'Error al procesar la transacción';
            const toast = await this.toastCtrl.create({
              message: `${resVal || 'DECLINED'}: ${errorDesc}`,
              buttons: [{ icon: 'close' }],
              color: 'danger',
              duration: 3000,
            });

            await toast.present();

            resolve(null);
          }
        },
        onReady: (result: any) => {
          this.isLoading = false;
          // console.log('ready', result, typeof checkout.getApms);

          // checkout.getApms(
          //   {
          //     currencyCode: 'MXN',
          //     countryCode: 'MX', //detect
          //     languageCode: 'es',
          //   },
          //   (r: any) => {
          //     console.log('apms', r);
          //   }
          // );
        },
        upoDeleted: (paymentDetails: any) => {
          // console.log('upoDeleted', paymentDetails);
          if (paymentDetails.paymentMethod === 'cc_card') {
            this.nuveiS?.removeCard(paymentDetails);
          }
        },
        payButton: 'textButton',
        // pmWhiteList: ['cc_card', 'apmgw_STPmex', 'apmgw_PayCash'],
        pmBlacklist: ['apmgw_Oxxo'],
        selectPM: 'none',
        selectUpo: 'first',
        merchantLocale: 'es_MX',
        i18n: {
          pay_with: 'Pagar con ',
          cc_card: 'Tarjeta',
          apmgw_STPmex: 'SPEI',
          apmgw_PayCash: 'Efectivo',
          always_save_apm_msg: 'Al continuar, usted acepta el almacenamiento seguro para uso futuro',
          always_save_card_msg: 'Al continuar, usted acepta el almacenamiento seguro de su tarjeta para uso futuro',
          del_confirm_msg: 'Una vez eliminado, este método de pago ya no estará disponible. ¿Estás seguro?',
        },
        cardWhiteList: ['visa', 'mastercard'],
        // blockCards: ['amex'],
      };

      // console.log(JSON.stringify(configCheckout, null, 2));

      // Configurar el checkout de Nuvei
      checkout(configCheckout);
    });
  }

  cleanupNuveiResources() {
    // 1. Eliminar el script del DOM
    if (this.nuveiScript && document.body.contains(this.nuveiScript)) {
      this.renderer.removeChild(document.body, this.nuveiScript);
      this.nuveiScript = null;
    }

    // console.log('Recursos de Nuvei limpiados.');
  }

  async changeAmount() {
    const mp = this.mins.find((m) => m.mp === this.mp)!;
    const alert = await this.alertCtrl.create({
      header: 'Monto a recargar',
      message: `El monto mínimo para ${this.translateS.instant('nuvei.pm.' + mp.mp)} de $${mp.min}.00`,
      inputs: this.founds
        .filter((v) => v >= mp.min)
        .map((value) => ({
          type: 'radio',
          label: `$${value}.00`,
          value: value,
          checked: this.amount === value,
          handler: (input) => {
            // console.log(input.value);
            const selected = input.value;
            if (selected) this.amount = parseInt(selected, 10);
            setTimeout(() => alert.dismiss(), 230);
          },
        })),
      buttons: [
        {
          text: 'Cerrar',
          role: 'cancel',
        },
      ],
    });

    await alert.present();
  }

  async updateAmount(ev: CustomEvent) {
    const value = +ev.detail['value'];
    const mp = this.mins.find((m) => m.mp === this.mp)!;

    const toastOption = {
      message: '',
      duration: 3000,
      buttons: [{ icon: 'close' }],
    };

    if (value < mp.min) {
      this.amount = mp.min;
      toastOption.message = `El monto mínimo para ${this.translateS.instant('nuvei.pm.' + mp.mp)} es de $${mp.min}.00`;
    } else if (value > this.max) {
      const currencyPipe = new CurrencyPipe('es-MX');
      this.amount = this.max;
      toastOption.message = `El monto máximo para recargar es de ${currencyPipe.transform(this.max, 'MXN')}`;
    } else {
      this.amount = value;
    }

    if (toastOption.message) {
      const toast = await this.toastCtrl.create(toastOption);
      await toast.present();
    }
  }

  // Función para seleccionar todo el texto al enfocar
  async selectAllText(event: CustomEvent): Promise<void> {
    try {
      const ionInput = event.target; // Obtenemos el componente ion-input
      const nativeInput = await (ionInput as any).getInputElement(); // Obtenemos el input nativo
      nativeInput.select(); // Seleccionamos todo el texto
    } catch (error) {}
  }
  trackWallet(
    event: AnalyticsEventName,
    amount: number,
    status: string,
    payMethod?: string,
    transactionId?: string,
    errorCode?: string,
    requestId?: string,
    isKlaviyo?: boolean,
    isPixel?: boolean
  ) {
    const eventData: any = {
      amount: amount,
      status: status,
    };

    if (payMethod) eventData.pay_method = payMethod;
    if (transactionId) eventData.transaction_id = transactionId;
    if (errorCode) eventData.error_code = errorCode;
    if (requestId) eventData.request_id = requestId;

    this.trackingS.trackEvent(
      event,
      eventData,
      isKlaviyo, //isKlaviyo
      isPixel
    ); // isPixel
  }

  /**
   * Tracking de campaign_conversion para recargas de saldo
   */
  trackCampaignConversion(amount: number, transactionId: string, payMethod: string) {
    const utmParams = this.campaignS.getUTMParams();
    const hasUTM = utmParams && Object.values(utmParams).some((v) => v !== null);

    if (hasUTM) {
      this.trackingS.trackEvent(
        'campaign_conversion',
        {
          ...utmParams,
          conversion_type: 'recarga',
          amount: amount,
          transaction_id: transactionId,
          pay_method: payMethod,
        },
        false,
        true
      );
    }
  }

  async blurInput() {
    const previous = +(this.inputAmount.value as string | number);
    if (previous < this.min) {
      const alert = await this.alertCtrl.create({
        header: `El monto mínimo para ${this.translateS.instant(`nuvei.pm.${this.mp}`)}: ${formatCurrency(
          this.min,
          'es-MX',
          '$'
        )}`,
        buttons: [this.translateS.instant('Close')],
      });

      await alert.present();
    }
    this.inputAmount.value = this.amount;
  }

  async getLimitForAddFunds(credentials: Credentials) {
    if (!this.topS || !this.transactionS) return -1;
    // obtener el limite segun el nuvel de usuario
    const top = await this.topS.getTop(credentials.id);

    // console.log({ top });

    // usuario level 0 (sin verificacion minima)
    let limit = 700;

    if (top?.isActive) {
      //usuario top level 3
      limit = 0;
    } else {
      // level 2 con documents verificado (estado cuenta, tarjeta otros)
      if (credentials.customer.documentVerified) {
        limit = 10000;
      }

      //level 1 con verificacion basica (ine,numero y email)
      else if (
        credentials.customer.emailVerified &&
        credentials.customer.phoneVerified &&
        credentials.customer.idVerified
      ) {
        limit = 2500;
      }
    }

    // console.log({ limit });

    // get transaction de los ultimos 30 dias que sean recargas completas y pendientes validas
    const transactions = await this.transactionS.getTransactionAddFundsLimit(credentials.id);
    // console.log('transaction limit', transactions);
    const filtered = transactions.filter(
      (t) => (t.status === 'pending' && t.data?.save?.method !== 'apmgw_STPmex') || t.status === 'completed'
    );

    const total = filtered.reduce((a, b) => a + b.amount, 0);

    // console.log({ total, limit });

    if (total && limit) {
      if (total >= limit) return -1;
      return limit - total;
    }

    return limit;
  }
}
